import { useTranslation } from 'react-i18next';

/**
 * Vrátí funkci pro formátování datumu podle aktuálního i18n locale.
 * Použití: const formatDate = useDateFormat();
 *          formatDate(user.createdAt) → '24. 3. 2026' (cs) / '3/24/2026' (en)
 * Podporuje také Firestore Timestamp objekty ({ _seconds: number }).
 */
const useDateFormat = () => {
    const { i18n } = useTranslation();

    return (date: Date | string | number | { _seconds: number } | null | undefined): string => {
        if (!date) return '–';
        let d: Date;
        if (date instanceof Date) {
            d = date;
        } else if (typeof date === 'object' && '_seconds' in date) {
            d = new Date(date._seconds * 1000);
        } else {
            d = new Date(date as string | number);
        }
        return isNaN(d.getTime()) ? '–' : d.toLocaleDateString(i18n.language);
    };
};

export default useDateFormat;
